require('./cardBenefitsLinks.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const withContactCenterValidation = require('utilities/withContactCenterValidation');
//@commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
//@const
const TRANSLATION_KEY = 'cardsBenefitsLinks-';

const CardsBenefitsLinks = ({
                                hasDiamondCard,
                                hasPremiumCard,
                                hasR42BenefitsAccess,
                                cardId
                            }) => {
    const title = formatText(`${TRANSLATION_KEY}title`);

    let diamondLink;
    let premiumLink;
    let r42Link;
    
    let cardIdUrl = cardId != undefined ? `/${cardId}` : '';
    if (!!hasDiamondCard) {
        diamondLink = (
            <OKLink
                modifier="complementary"
                to={`/myprofile/cards${cardIdUrl}/benefits/diamond`}>
                <FormattedText value={`${TRANSLATION_KEY}cardsBenefitsLinks_diamondLinkTitle`} />
            </OKLink>);
    }

    if (!!hasPremiumCard) {
        premiumLink = (
            <OKLink
                modifier="complementary"
                to={`/myprofile/cards${cardIdUrl}/benefits/premium`}
            >
                <FormattedText value={`${TRANSLATION_KEY}cardsBenefitsLinks_premiumLinkTitle`} />
            </OKLink>);
    }

    if (!!hasR42BenefitsAccess) {
        r42Link = (
            <OKLink
                modifier="complementary"
                to={`/myprofile/cards${cardIdUrl}/benefits/r42`}
            >
                <FormattedText value={`${TRANSLATION_KEY}cardsBenefitsLinks_r42LinkTitle`} />
            </OKLink>
        );
    }

    return (
        <OKSectionBox title={title}>
            <div className="cards-benefits-links__item">
                {diamondLink}
            </div>
            <div className="cards-benefits-links__item">
                {premiumLink}
            </div>
            <div className="cards-benefits-links__item">
                {r42Link}
            </div>
        </OKSectionBox>
    );
};

CardsBenefitsLinks.propTypes = {
    hasDiamondCard: PropTypes.bool.isRequired,
    hasPremiumCard: PropTypes.bool.isRequired,
    hasR42BenefitsAccess: PropTypes.bool.isRequired,
    cardId: PropTypes.string.isRequired
};

module.exports = CardsBenefitsLinks;
module.exports.CardsBenefitsLinksCCValidated = withContactCenterValidation(module.exports);
